import React, { useState } from "react";
import { ArrowRight as ArrowRightIcon, SwapHoriz as SwapHorizIcon } from "@mui/icons-material";
import { ListItemIcon } from "@mui/material";

import { useGetAccountsQuery, useGetUserMeAccountsQuery } from "fond/api";
import { useAccountSwitching } from "fond/hooks/useAccountSwitching";
import AccountMenuItems from "fond/topBar/AccountMenuItems";
import { MenuItem, MenuItemContentWrapper, Tooltip } from "fond/topBar/switchAccountMenuItem.styles";

interface IProps {
  onClose: () => void;
}

const SwitchAccountMenuItem: React.FC<IProps> = ({ onClose }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const { initiateSwitch, modal: accountSwitchingModal } = useAccountSwitching();

  useGetAccountsQuery();
  useGetUserMeAccountsQuery();

  const onAccountSwitch = () => {
    setShowTooltip(false);
    onClose();
  };

  const handleAccountClick = (accountId: string, accountName: string) => {
    initiateSwitch(accountId, accountName);
  };

  return (
    <>
      <Tooltip
        open={showTooltip}
        onOpen={() => setShowTooltip(true)}
        onClose={() => setShowTooltip(false)}
        placement="left-start"
        title={<AccountMenuItems onAccountSwitch={onAccountSwitch} onAccountClick={handleAccountClick} />}
        leaveDelay={500}
      >
        <MenuItem data-testid="switch-account">
          <MenuItemContentWrapper>
            <ListItemIcon>
              <SwapHorizIcon />
            </ListItemIcon>
            Switch workspace
          </MenuItemContentWrapper>
          <ArrowRightIcon />
        </MenuItem>
      </Tooltip>
      {accountSwitchingModal}
    </>
  );
};

export default SwitchAccountMenuItem;
